import { media, styled } from '@styles';
import { css } from 'styled-components';

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  ${media.xSmallScreen`
    // margin-top: 140px;
    margin-top: 40px;
  `}
  ${media.smallestScreen`
    margin-top: 30px;
  `}
  .button {
    padding: 0;
    height: 50px;
    min-width: 170px;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 3px;

    ${media.largeScreen`
      min-width: 120px;
      height: 42px;
      font-size: 13px;
      line-height: 13px;
    `}
  }

  .cancel {
    margin-right: 20px;
    ${media.mediumScreen`
      margin: 0;
    `}
  }
`;

export const Content = styled.div`
  padding: 80px 50px 35px;
  ${media.largeScreen`
    padding: 50px 38px;
  `}
  ${media.mediumScreen`
    width: 100vw;
    padding: 40px;
  `}
`;

export const Wrapper = styled.div`
  min-width: 650px;
  ${media.mediumScreen`
    min-width: initial;
    width: 100%;
  `}
`;

export const Row = styled.div<{ buttons?: boolean }>`
  display: flex;
  align-items: center;
  ${media.mediumScreen`
    flex-direction: column;
  `}
  ${({ buttons }) => css`
    ${buttons &&
    css`
      justify-content: flex-end;
    `}
  `}
`;

export const Slider = styled.div`
  margin-left: 20px;
  position: relative;
  width: 100%;
  ${media.smallScreen`
    margin: 0;
    display: flex;
  `}
`;

export const EdgeValues = styled.div<{ type: 'min' | 'max'; active?: boolean }>`
  position: absolute;
  top: -21px;
  font-family: ${({ theme }) => theme.typography.extraFontFamily};
  font-size: ${({ theme }) => theme.typography.labelFontSize};
  color: ${({ theme }) => theme.colors.graySemi};
  font-weight: 500;
  line-height: 160%;
  opacity: 0.5;
  ${media.mediumScreen`
    position: relative;
    top: -5px;
    white-space: nowrap;
  `}
  ${({ theme, type, active }) => css`
    ${type === 'min' &&
    css`
      left: -20px;
      ${media.mediumScreen`
        left: -10px;
      `}
    `}
    ${type === 'max' &&
    css`
      right: -35px;
      ${media.mediumScreen`
        right: -10px;
      `}
    `}
    ${active &&
    css`
      color: ${theme.colors.blueLight};
      opacity: 1;
    `}
  `}
`;

export const ResetButton = styled.button`
  margin-left: 25px;
  font-size: ${({ theme }) => theme.typography.labelFontSize};
  line-height: 160%;
  text-align: center;
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.graySemi};
  white-space: nowrap;
  ${media.largeScreen`
    margin-left: 25px;
  `}
  ${media.mediumScreen`
    margin-left: 0;
    margin-top: 25px;
  `}
`;

export const Message = styled.span`
  font-family: ${({ theme }) => theme.typography.extraFontFamily};
  font-size: ${({ theme }) => theme.typography.labelFontSize};
  line-height: 160%;
  text-align: center;
  color: ${({ theme }) => theme.colors.graySemi};
  white-space: nowrap;
  display: block;
  padding-bottom: 25px;
`;
